(function () {
    'use strict';

    angular
        .module('app')
        .factory('EntityFieldImage', EntityFieldImageFactory);

    EntityFieldImageFactory.$inject = ['EntityFieldScalar'];

    function EntityFieldImageFactory(EntityFieldScalar) {

        /**
         * @constructor
         * @name EntityFieldImage
         */
        function EntityFieldImage(name, value) {
            EntityFieldScalar.call(this, name, value);
        }

        EntityFieldImage.prototype = Object.create(EntityFieldScalar.prototype);
        EntityFieldImage.prototype.constructor = EntityFieldImage;

        EntityFieldImage.prototype.toString = function () {
            return '[object EntityFieldImage]';
        };

        return EntityFieldImage;
    }
})();